export const TagStyles = {
  'Root Cause': {
    backgroundColor: '#FFEBE9',
    color: '#D1242F',
    borderColor: 'rgba(255, 129, 130, 0.40)',
  },
  Effect: {
    backgroundColor: '#FFF1E5',
    color: '#BC4C00',
    borderColor: 'rgba(251, 143, 68, 0.40)',
  },
};

export const FAILURE_OPTIONS = [
  { name: 'Product Bug', value: 'Product' },
  { name: 'Unknown Bug', value: 'Unknown' },
  { name: 'Environment Issue', value: 'Environment' },
  { name: 'Automation Bug', value: 'Automation' },
];

export const CUSTOM_OPTION = { name: 'Custom', value: 'custom' };

export const POSITIVE_FEEDBACK_PAYLOAD = { rating: 10 };
export const NEGATIVE_FEEDBACK_PAYLOAD = { rating: 1 };

export const RCA_FEEDBACK_MESSAGES = {
  thumbsUp: 'Thanks for your feedback!',
  thumbsDown:
    'Thanks for your feedback! Please suggest how we can improve.',
  formSubmit:
    'Your changes are saved and will enhance future RCA results.',
};

export const POLLING_INTERVAL_MS = 10000;
export const MAX_POLL_COUNT = 30;

export const FAILURE_STATUSES = ['failed', 'error', 'lambda_error', 'lambda error'];

export const APP_PREFIXES = ['APP', 'RMAA', 'NAAV', 'RAW'];

export const STATUS_COLOR_MAP = {
  passed: '#176F2C',
  failed: '#CF222E',
  skipped: '#666666',
  'not started': '#0969DA',
  'in progress': '#666666',
  idle_timeout: '#FFB302',
  timeout: '#FFB302',
  queued_timeout: '#8250DF',
  queue_timeout: '#8250DF',
  'queue timeout': '#8250DF',
  completed: '#666666',
  cancelled: '#C24E00',
  stopped: '#A40E26',
  lambda_error: '#087493',
  'lambda error': '#087493',
  error: '#CF222E',
  running: '#0366D6',
  ignored: '#666666',
  queued: '#8250DF',
};
